<section class="page">
  <h1>Mes infos</h1>
  <spw-message
    *ngIf="message"
    [messageTitle]="'Succès'"
    variant="success"
    [isDismissable]="true"
    [dismissableText]="'Fermer'"
  >
    {{ message }}
  </spw-message>
  <spw-message
    *ngIf="errorMessage"
    [messageTitle]="'Erreur'"
    variant="alert"
    [isDismissable]="true"
    [dismissableText]="'Fermer'"
  >
    {{ errorMessage }}
  </spw-message>

  <div class="card">
    <div class="summary">
      <div><strong>Prénom :</strong> {{ prenom }}</div>
      <div><strong>Nom :</strong> {{ nom }}</div>
      <div><strong>Email :</strong> {{ email }}</div>
      <div><strong>Plateau :</strong> {{ plateau }}</div>
    </div>
    <spw-text-field
      label="Tasses par jour"
      type="number"
      name="tassesParJour"
      [value]="tassesParJour"
      [min]="0"
      (valueChanged)="tassesParJour = +$event.detail"
    ></spw-text-field>
    <spw-text-field
      label="Jours de présentiel / semaine"
      type="number"
      name="joursPresentielParSemaine"
      [value]="joursPresentielParSemaine"
      [min]="0"
      [max]="5"
      (valueChanged)="joursPresentielParSemaine = +$event.detail"
    ></spw-text-field>
    <div class="synthesis">
      <strong>Synthèse :</strong> {{ tassesParSemaine }} tasses / semaine
    </div>
    <spw-button variant="primary" [disabled]="isLoading" (click)="save()">
      {{ isLoading ? 'Enregistrement...' : 'Enregistrer' }}
    </spw-button>
  </div>
</section>
